import { Delivery } from "../common/GetDeliveriesDetailsGQLResponse";
import { TableColumnConfigCommon } from "../common/TableColumnConfig";
import Popover from "@amzn/awsui-components-react-v3/polaris/popover";
import React from "react";
import Icon from "@amzn/awsui-components-react-v3/polaris/icon";
import {TABLE_COLUMN_HEADER_ICON} from "../LmdpConstants";

export const getCSVData = (items: readonly any[] | readonly Delivery[], config: any[] | readonly TableColumnConfigCommon<any>[]) => {
    return items.map((item: any) => {
        const rowData: Record<string, string> = {};
        config.forEach(column => {
            const csvHeader: string = column.label;
            rowData[csvHeader] = String(column.csvText(item));
        });
        return rowData;
    });
};

export const getColumnHeader = (headerText: any, hoursToUpdate: string | undefined) => {
    return (
        <>
            {headerText} &nbsp;
            {hoursToUpdate ? getPopover(TABLE_COLUMN_HEADER_ICON.UPDATE_SLA(hoursToUpdate!)) : undefined}
        </>
    );
}

export const getPopover = (iconText: string) => {
    return (
        <Popover
            dismissButton={false}
            size="small"
            triggerType="custom"
            content={
                <React.Fragment>
                    {iconText}
                </React.Fragment>
            }
        >
            <Icon variant="subtle" name="status-info"></Icon>
        </Popover>
    );
}